import React from 'react';

function BreadcrumbNav({ items = [] }) {
  return (
    <nav className="breadcrumb-wrapper" aria-label="Caminho de navegação">
      <div className="container-fluid px-md-5"> {/* Alinhado com o conteúdo principal */}
        <ol className="breadcrumb">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li 
                key={index} 
                className={`breadcrumb-item ${isLast ? 'active' : ''}`} 
                aria-current={isLast ? 'page' : undefined}
              >
                {item.href && !isLast ? (
                  <a href={item.href} className="breadcrumb-link">
                    {item.icon && <i className={`${item.icon} me-1`}></i>}
                    {item.label}
                  </a>
                ) : (
                  <span className="breadcrumb-current">
                    {item.icon && <i className={`${item.icon} me-1`}></i>}
                    {item.label}
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </div>

      <style>{`
        .breadcrumb-wrapper {
          padding: 1rem 0;
          background: #ffffff; /* Fundo branco para não "sujar" o layout */
          border-bottom: 1px solid #eee;
          margin-bottom: 0;
        }

        .breadcrumb {
          margin-bottom: 0;
          background: transparent;
          padding: 0;
          display: flex;
          flex-wrap: wrap;
          list-style: none;
        }

        .breadcrumb-item {
          display: flex;
          align-items: center;
          font-size: 0.85rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .breadcrumb-link {
          text-decoration: none;
          color: #198754; /* Verde sucesso */
          font-weight: 600;
          transition: color 0.2s ease;
        }

        .breadcrumb-link:hover {
          color: #f6cc31; /* Amarelo no hover para seguir a identidade */
          text-decoration: none;
        }

        .breadcrumb-current {
          color: #6c757d;
          font-weight: 400;
        }

        /* Custom Separator */
        .breadcrumb-item + .breadcrumb-item {
          padding-left: 0.75rem;
        }

        .breadcrumb-item + .breadcrumb-item::before {
          content: "/";
          float: left;
          padding-right: 0.75rem;
          color: #dee2e6;
          font-weight: 300;
        }

        @media (max-width: 768px) {
          .breadcrumb-wrapper {
            padding: 0.75rem 1rem;
          }
          .breadcrumb-item {
            font-size: 0.75rem;
          }
        }
      `}</style>
    </nav>
  );
}

export default BreadcrumbNav;